import { Button } from '@lb-classroom/ui';
import { WithTranslation } from 'next-i18next';
import React from 'react';
import { withTranslation } from 'next-i18next';

interface Props extends WithTranslation {
  t: any;
  saving: boolean;
  handleClick: (e: any) => void;
  lessonDuration: any;
  timeSentence: React.ReactNode | string;
  dateSentence: React.ReactNode | string;
  ticketSentence: React.ReactNode | string;
}

const CancelBookingModalMain: React.FC<Props> = ({
  handleClick,
  saving,
  lessonDuration,
  timeSentence,
  dateSentence,
  ticketSentence,
  t,
}: Props) => {
  return (
    <div className="">
      <div className="description mb-4">
        {t('classes.durationSentence', { duration: lessonDuration })}
      </div>
      <div className="time mb-4">
        <span className="strong booking-modal-list-title">
          {t('general.time')}:{' '}
        </span>
        {timeSentence}
      </div>
      <div className="Date mb-4">
        <span className="strong booking-modal-list-title">
          {t('general.date')}:{' '}
        </span>
        {dateSentence}
      </div>
      <div className="Consume mb-4">
        <span className="strong booking-modal-list-title">
          {t('general.returnOnCancel')}:{' '}
        </span>
        {ticketSentence}
      </div>
      <div className="book-button text-right">
        <Button onClick={handleClick} disabled={saving}>
          {t('classes.cancel')}
        </Button>
      </div>
    </div>
  );
};

export default withTranslation('common')(CancelBookingModalMain);
